import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function AImageLink({ img, to }) {
	return (
		<Link to={to} href={to} className="a-image-link">
			<img src={img} alt="" />
		</Link>
	);
}

AImageLink.propTypes = {
	img: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.image-link.js